import { useCallback, useMemo } from 'react';

import { ShadowProperties } from './Shadow';

export const useShadowProperties = (value?: string, isFilter?: boolean) => {
  let individualValues: any;

  if (isFilter && value?.includes('drop-shadow')) {
    individualValues = (value ?? '').match(/.*drop-shadow\(([-\da-zA-z# ]+)\).*/)?.[1] ?? '';
  } else {
    individualValues = value ?? '';
  }

  individualValues = individualValues
    .split(' ')
    .map((v: string) => v.replace(`px`, ``)) as string[];

  const values = useMemo(() => {
    return {
      offsetX: parseFloat(individualValues[0] || '0'),
      offsetY: parseFloat(individualValues[1] || '0'),
      blur: parseFloat(individualValues[2] || '0'),
      spread: isFilter ? 0 : parseFloat(individualValues[3] || '0'),
      color: (isFilter ? individualValues[3] : individualValues[4]) || '#D2D6DB',
    };
  }, [individualValues]);

  const updateValue = useCallback(
    (newValue: number | string, shadowProperty: ShadowProperties) => {
      const newValues = { ...values, [shadowProperty]: newValue };
      if (isFilter) {
        return `drop-shadow(${newValues.offsetX}px ${newValues.offsetY}px ${newValues.blur}px ${newValues.color})`;
      }
      return `${newValues.offsetX}px ${newValues.offsetY}px ${newValues.blur}px ${newValues.spread}px ${newValues.color}`;
    },
    [values],
  );
  return {
    values,
    updateValue,
  };
};
